import QrLogArriveForm from "../features/qr-arrived/components/qr-log-arrive-form"

export default function QrArriveView() {
  return (
    <>
      <QrLogArriveForm/>
    </>
  )
}